// @ts-strict-ignore

import { addExperimentGroupToTargeting } from '@platforms/shared';
import {
	BaseServiceSetup,
	context,
	defineExperiment,
	Experiment,
	getExperiment,
	isExperimentEnabled,
	utils,
} from '@wikia/ad-engine';

type RunningExperimentType = Experiment | null | undefined;

const logGroup = 'UcpDesktopNoSecondaryVideoExperiment';

export class UcpDesktopNoSecondaryVideoExperiment extends BaseServiceSetup {
	private pathfinderExperimentVariantNames = {
		control1: 'desktop-cotech-1896-control1',
		control2: 'desktop-cotech-1896-control2',
		active: 'desktop-cotech-1896-variant1',
	};

	private pathfinderExperimentVariants = [
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.control1,
			buckets: ['12', '13', '14'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.control2,
			buckets: ['18', '19', '20'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.active,
			buckets: ['15', '16', '17'],
		}),
	];

	call(): void {
		this.configure();
	}

	private pathfinderActiveExperimentVariant: RunningExperimentType = getExperiment(
		this.pathfinderExperimentVariants,
	);

	private configure() {
		if (
			!isExperimentEnabled(
				this.instantConfig,
				'noSecondaryVideoExperiment',
				this.pathfinderActiveExperimentVariant,
			)
		) {
			utils.logger(logGroup, 'Experiment disabled');
			context.set('experiments.noSecondaryVideo', false);
			return;
		}

		if (!this.pathfinderActiveExperimentVariant?.name) {
			return;
		}

		const variantName = this.pathfinderActiveExperimentVariant.name;

		switch (variantName) {
			case this.pathfinderExperimentVariantNames.active:
				utils.logger(logGroup, 'Variant Group');
				context.set('experiments.noSecondaryVideo', true);
				addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.active);
				break;
			case this.pathfinderExperimentVariantNames.control1:
				utils.logger(logGroup, 'Control 1 Group');
				context.set('experiments.noSecondaryVideo', false);
				addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.control1);
				break;
			case this.pathfinderExperimentVariantNames.control2:
				utils.logger(logGroup, 'Control 2 Group');
				context.set('experiments.noSecondaryVideo', false);
				addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.control2);
				break;
			default:
				return;
		}
	}
}
